import { useExtendWithSubnetworks, useNetworksStateContext } from "@l2r-front/l2r-networks"

import { API_MODULE_MIRANDA } from "../../../../../common/constants/appRoad"

import { mirandaQueryKeys } from "./queryKeys"
import { useMirandaQuery } from "./useMirandaQuery"

export const useMirandaStats = (queryParams, config = {}) => {
    const url = "network_grades/stats/"
    const { selectedNetwork } = useNetworksStateContext()

    const parameters = useExtendWithSubnetworks(queryParams, API_MODULE_MIRANDA)

    const queryKey = mirandaQueryKeys.stats(selectedNetwork?.slug, parameters)

    return useMirandaQuery(
        url,
        queryKey,
        { project: selectedNetwork?.slug, ...parameters },
        {
            enabled: !!selectedNetwork,
            ...config,
        },
    )
}